import React, {useMemo} from 'react'
import styles from './SocialLinks.module.scss'
import {T, useUIGlobalContext} from '@colonist/ui'
import SocialDiscord from '@static/images/social_icon_discord.svg'
import SocialYoutube from '@static/images/social_icon_youtube.svg'
import SocialReddit from '@static/images/social_icon_reddit.svg'
import SocialInstagram from '@static/images/social_icon_instagram.svg'
import SocialFacebook from '@static/images/social_icon_facebook.svg'
import SocialX from '@static/images/social_icon_x.svg'

export interface SocialLinkData {
    icon: string
    url: string
    ariaLabel: string
}

export interface SocialLinksProps {
    className?: string
}

export const SocialLinks = ({
    className,
}: SocialLinksProps) => {
    const {discordUrl} = useUIGlobalContext()

    const socialLinks = useMemo(() => [
        {icon: SocialDiscord, url: discordUrl, ariaLabel: 'Discord'},
        {icon: SocialYoutube, url: 'https://www.youtube.com/channel/UCkmPiTR8n0zqT6tIuUK0klA', ariaLabel: 'YouTube'},
        {icon: SocialReddit, url: 'https://www.reddit.com/r/Colonist/', ariaLabel: 'Reddit'},
        {icon: SocialInstagram, url: 'https://www.instagram.com/colonist_io/', ariaLabel: 'Instagram'},
        {icon: SocialFacebook, url: 'https://www.facebook.com/colonistio/', ariaLabel: 'Facebook'},
        {icon: SocialX, url: 'https://x.com/colonistio', ariaLabel: 'X'},
    ], [discordUrl])

    return (
        <div className={className}>
            <h3 className={styles.headerText}><T id="strings:morePage.followUs" /></h3>
            <div className={styles.row}>
                {socialLinks.map((link) => (
                    <a
                        key={link.ariaLabel}
                        className={styles.iconLink}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={link.ariaLabel}
                    >
                        <img className={styles.icon} src={link.icon} alt={link.ariaLabel} />
                    </a>
                ))}
            </div>
        </div>
    )
}
